import { DocumentVerifiedIcon, LoadingIcon, ShieldDoneIcon, Typography } from "@cpj-ai/panel-npm-package";
import { TCertificateStatus } from "../CertifiedDocumentCard";

const CertificateStatusBadge = ({ status }: { status?: TCertificateStatus }) => {
  const statusBaseClasses = "flex gap-1 items-center py-1 px-2 w-fit rounded-lg mt-3";

  switch (status) {
    case "VERIFIED":
      return (
        <div className={`${statusBaseClasses} bg-green-600`}>
          <DocumentVerifiedIcon stroke="#fff" width={24} height={24} />
          <Typography className="text-white text-xs font-semibold">Verified</Typography>
        </div>
      );
    case "NOT_VERIFIED":
      return (
        <div className={`${statusBaseClasses} bg-[#F5A524]`}>
          <LoadingIcon stroke="#fff" width={24} height={24} />
          <Typography className="text-white text-xs font-semibold">Not verified yet</Typography>
        </div>
      );
    case "VERIFIED_BY_JOB_SEEKER":
      return (
        <div className={`${statusBaseClasses} bg-cyan-500`}>
          <ShieldDoneIcon stroke="#fff" width={24} height={24} />
          <Typography className="text-white text-xs font-semibold">Verified by the job seeker</Typography>
        </div>
      );
    default:
      return (
        <div className={`${statusBaseClasses} bg-zinc-500`}>
          <Typography className="text-white text-xs font-semibold lowercase">{status?.replace("_", " ")}</Typography>
        </div>
      );
  }
};

export default CertificateStatusBadge;
